<template>
    <div class="fill-height grey lighten-4">
        <RomaLessonDetail />
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import RomaLessonDetail from "@/components/lesson/RomaLessonDetail.vue";
export default {
    data() {
        return {
            buttonOptions: {
                title: "Lista de actividades",
                icon: "mdi-plus",
                color: "accent"
            }
        };
    },
    components: {
        RomaLessonDetail
    },
    mounted() {
        this.setLayout("main-layout");
    },
    computed: {
        ...mapGetters({
            layout: "getLayout"
        })
    },
    methods: {
        ...mapActions({
            setLayout: "setLayout",
            toastSuccess: "toastSuccess",
            toastError: "toastError"
        })
    }
};
</script>
<style lang="scss"></style>
